import React from 'react'


const check = (obj) => {
  if (obj.allowed) {
    return true
  }
  return false
}
const Can = (props) => {
  return check(props.obj) ? props.children : null
}

export default Can